export class Controller {

    /** @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
        if(this.idpAuthenticator == null) {
            this.$state.go('company.idp-authenticators.list');
            return;
        }
    }

    showAssignApplicationButton() {
    	return this.$state.is('company.idp-authenticators.manage.applications');
    }

}



// WEBPACK FOOTER //
// ./src/portal/states/company/idp-authenticators/manage/idp-authenticator-manage.controller.js